import type { EmailStarterTemplate } from '../types'

/**
 * "Thank you for your order" — warm, confident, confirms order + ships CTA.
 * The body sits inside tagada's OrderPaid React Email shell (header/footer/
 * order-summary table), so the body focuses on the personal message.
 */
export const orderPaidStarter: EmailStarterTemplate = {
    id: 'order-paid-classic',
    label: 'Classic thank-you',
    description: 'Warm receipt with order details and a clear CTA to track.',
    icon: 'CheckCircle2',
    accent: '#059669',
    defaultSubject: 'Thanks for your order, {{ customerFirstName }}!',
    defaultPreheader: 'Your order is confirmed. We will email you once it ships.',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: { level: 1, textAlign: 'left' },
                content: [
                    { type: 'text', text: 'Thank you, ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'friend',
                            required: false,
                        },
                    },
                    { type: 'text', text: '!' },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Your order is confirmed. We are preparing everything with care and will send another email the moment it ships.',
                    },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        marks: [{ type: 'bold' }],
                        text: 'Order number: ',
                    },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'orderNumber',
                            label: 'orderNumber',
                            fallback: '',
                            required: true,
                        },
                    },
                ],
            },
            {
                type: 'emailButton',
                attrs: {
                    text: 'Track my order',
                    url: '{{ orderTrackingUrl }}',
                    align: 'left',
                    variant: 'filled',
                    radius: 'smooth',
                    bgColor: '#059669',
                    textColor: '#ffffff',
                },
            },
            { type: 'emailSpacer', attrs: { height: 16 } },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'If you have any questions, just reply to this email — a real person will get back to you within one business day.',
                    },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Thanks again,' },
                    { type: 'hardBreak' },
                    { type: 'text', marks: [{ type: 'bold' }], text: 'The ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'storeName',
                            label: 'storeName',
                            fallback: 'team',
                            required: false,
                        },
                    },
                    { type: 'text', marks: [{ type: 'bold' }], text: ' team' },
                ],
            },
        ],
    },
}
